// Lib
import React, { useState } from 'react';

// Components
import Button from '../../../../../../../components/buttons/Button';
import AiAssistantPopupResultHistory from './AiAssistantPopupResultHistory';

// Types
import { AiDebugInfo } from '../../../../../../../../common/ai/aiConversationTypes';

// Styles
import './AiAssistantPopupResultDebugInfo.scss';

const AiAssistantPopupResultDebugInfo = ({ result }: { result: AiDebugInfo }): React.ReactElement => {
    const [expanded, setExpanded] = useState(false);

    return (
        <AiAssistantPopupResultHistory className="AiAssistantPopupResultDebugInfo">
            <Button onClick={() => setExpanded(!expanded)}>
                {expanded ? <span className="expand-arrow">▼</span> : <span className="expand-arrow">►</span>} Debug
                info
            </Button>

            {expanded ? (
                <>
                    <div className="debug-output">
                        <div className="debug-output-title">Prompt</div>
                        <textarea disabled value={JSON.stringify(result.debugInfo?.prompt, null, 2)} />
                    </div>
                    <div className="debug-output">
                        <div className="debug-output-title">Completion</div>
                        <textarea disabled value={result.debugInfo?.completionContent} />
                    </div>
                    <div className="debug-output">
                        <div className="debug-output-title">Token usage</div>
                        <p>Model: {result.debugInfo?.usage.model}</p>
                        <p>Prompt: {result.debugInfo?.usage.prompts}</p>
                        <p>Completion: {result.debugInfo?.usage.completions}</p>
                    </div>
                </>
            ) : null}
        </AiAssistantPopupResultHistory>
    );
};

export default AiAssistantPopupResultDebugInfo;
